import { render, staticRenderFns } from "./TaskTable.vue?vue&type=template&id=f2f61116&scoped=true&"
import script from "./TaskTable.vue?vue&type=script&lang=js&"
export * from "./TaskTable.vue?vue&type=script&lang=js&"
import style0 from "./TaskTable.vue?vue&type=style&index=0&id=f2f61116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f61116",
  null
  
)

export default component.exports